<template>
    <div class="min_height">
        <ModuleMenu :moduleId="module_id" />
        <v-dialog v-model="feedbackDialog" width="72%" elevation="8" dark fade>
            <v-card :color="feedback_type">
                <div class="headline text-center py-4">{{ feedback_msg }}</div>
            </v-card>
        </v-dialog>
        <v-container>
            <div class="mb-10">
                <h1>Your Inquired Listings</h1>
                
                <v-card v-if="!readyToLoadInquired" class="d-flex justify-center elevation-0" style="background-color:#EFEFEF">
                    <v-progress-circular indeterminate color="primary" class="my-12" size="60" width="3"></v-progress-circular>
                </v-card>

                <div v-if="readyToLoadInquired && !interestListings.length">
                    <p class="ma-2">You have not expressed interest on any practices yet.</p>
                    <router-link :to="`/buyer_listings`" push class="button_link"><v-btn class="ma-2" color="primary" dark>View Listings</v-btn></router-link>
                </div>
                
                <v-data-iterator
                    v-if="readyToLoadInquired && interestListings.length"
                    :items="interestListings"
                    item-key="id"
                    :search="search"
                    hide-default-footer
                >                         
                    <template v-slot:default="props">
                        <div fluid grid-list-md>
                            <v-layout wrap>
                                <v-flex 
                                    v-for="item in props.items" 
                                    :key="item.id"
                                    xs3
                                    my-2
                                    px-2>

                                    <v-card tile class="mx-0 px-0">
                                        <v-img class="d-flex d-block mx-0 px-0" :src="item.img"></v-img>
                                        <div class="d-flex d-block body-2 ma-0 pa-0" style="width: 100%">
                                            <div id="AUM" style="height: 70px; width: 32%;" class="d-flex d-inline flex-column align-center justify-center white--text error text-center">
                                                <div class="d-block body-2 font-weight-bold">{{ item.aum_text }}</div>
                                                <div class="d-block">AUM</div>
                                            </div>
                                            <div id="Revenue" style="height: 70px; width: 32%;" class="d-flex d-inline flex-column align-center justify-center white--text secondary text-center">
                                                <div class="d-block body-2 font-weight-bold">{{ item.rev_text }}</div>
                                                <div class="d-block">Revenue</div>
                                            </div>
                                            <div id="Type" style="height: 70px; width: 37%;" class="d-flex d-inline flex-column align-center justify-center white--text primary text-center">
                                                <div class="d-block body-2 font-weight-bold">{{ item.type_name }}</div>
                                                <!-- <div class="d-block">Listing</div> -->
                                            </div>
                                        </div>
                                    
                                        <v-card-text>
                                            <div class="d-flex justify-space-between">
                                                <div class="d-inline">
                                                    <div class="listing_header d-block">{{ item.listing_id }}</div>
                                                    <span class="listing_header_secondary d-block">{{ item.location }}</span>
                                                </div>
                                                <v-btn icon @click.native="updateListing(item.id, 'fav')" class="d-inline">
                                                    <v-icon large :color="item.fav_color">{{ icons.heartIcon }}</v-icon>
                                                </v-btn>
                                            </div>

                                            <div class="d-flex justify-space-between">
                                                <!-- <v-btn v-if="!item.offer_made" text :color="item.interest_type" @click="listingActions('interest', item.interest_toggle, item.id)" class="d-inline">{{ item.interest_text }}</v-btn>
                                                <v-btn v-if="item.offer_made" text :color="item.interest_type" class="d-inline">{{ item.interest_text }}</v-btn> -->
                                                <router-link :to="`/buyer_listings/${item.listing_id}`" push class="button_link"><div class="mt-4 view_listing">View Listing</div></router-link>
                                                <!-- <v-btn icon @click.native="showDesc(item)" class="mt-2">
                                                    <v-icon>{{ item.show ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                                </v-btn> -->
                                            </div>
                                        </v-card-text>
                                        
                                        <v-slide-y-transition>
                                            <v-card-text v-show="item.show" v-html="item.description" style="border-top: 1px solid #ccc" class="mt-2"></v-card-text>
                                        </v-slide-y-transition>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </div>
                    </template>
                </v-data-iterator>
            </div>

            <!-- <div class="my-10">
                <h1>Favorited Listings</h1>

                <v-progress-circular v-if="!readyToLoadFavs" indeterminate color="primary" class="ma-3" style="2rem"></v-progress-circular>
                
                <div v-if="readyToLoadFavs && !favListings.length">
                    <p class="ma-2">You have not expressed interest on any practices yet.</p>
                    <router-link :to="`/buyer_listings`" push class="button_link"><v-btn class="ma-2" color="primary" dark>View Listings</v-btn> </router-link>
                </div>

                <v-data-iterator
                    v-if="readyToLoadFavs && favListings.length"
                    :items="favListings"
                    item-key="id"
                    :search="search"
                    hide-default-footer
                >                         
                    <template v-slot:default="props">
                        <div fluid grid-list-md>
                            <v-layout wrap>
                                <v-flex 
                                    v-for="item in props.items" 
                                    :key="item.id"
                                    xs3
                                    my-2
                                    px-2>

                                    <v-card tile class="mx-0 px-0">
                                        <div>
                                            <v-img class="d-flex d-block mx-0 px-0" :src="item.img"></v-img>
                                            <div class="d-flex d-block body-2" style="width: 100%">
                                                <div id="AUM" style="height: 70px; width: 32%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                                                    <div class="d-block body-2 font-weight-bold">{{ item.aum_text }}</div>
                                                    <div class="d-block">AUM</div>
                                                </div>
                                                <div id="Revenue" style="height: 70px; width: 32%;" class="d-flex flex-column align-center justify-center white--text secondary text-center">
                                                    <div class="d-block body-2 font-weight-bold">{{ item.rev_text }}</div>
                                                    <div class="d-block">Revenue</div>
                                                </div>
                                                <div id="Type" style="height: 70px; width: 37%;" class="d-flex flex-column align-center justify-center white--text primary text-center">
                                                    <div class="d-block body-2 font-weight-bold">{{ item.type_name }}</div>
                                                    < !-- <div class="d-block">Listing</div> -- >
                                                </div>
                                            </div>
                                        </div>
                                            
                                        <v-card-text>
                                            <div class="d-flex justify-space-between">
                                                <div class="d-inline">
                                                    <div class="listing_header d-block">{{ item.listing_id }}</div>
                                                    <span class="listing_header_secondary d-block">{{ item.location }}</span>
                                                </div>
                                                <v-btn icon @click.native="updateListing(item.id, 'fav')" class="d-inline">
                                                    <v-icon large :color="item.fav_color">{{ icons.heartIcon }}</v-icon>
                                                </v-btn>
                                            </div>

                                            <div class="d-flex justify-space-between">
                                                < !-- <v-btn v-if="!item.offer_made" text :color="item.interest_type" @click="listingActions('interest', item.interest_toggle, item.id)" class="d-inline">{{ item.interest_text }}</v-btn>
                                                <v-btn v-if="item.offer_made" text :color="item.interest_type" class="d-inline">{{ item.interest_text }}</v-btn> -- >
                                                <router-link :to="`/buyer_listings/${item.listing_id}`" push class="button_link"><div class="mt-4 view_listing">View Listing</div></router-link>
                                                < !-- <v-btn icon @click.native="showDesc(item)" class="mt-2">
                                                    <v-icon>{{ item.show ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                                </v-btn> -- >
                                            </div>
                                        </v-card-text>
                                        
                                        <v-slide-y-transition>
                                            <v-card-text v-show="item.show" v-html="item.description" style="border-top: 1px solid #ccc" class="mt-2"></v-card-text>
                                        </v-slide-y-transition>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </div>
                    </template>
                </v-data-iterator>
            </div> -->
            <div class="d-flex justify-end my-6">
                <!-- <v-btn @click.native="" class="elevation-0" color="success" style="color:#36480B; text-weight:900">
                    <v-icon large color="secondary">{{ icons.weChat }}</v-icon>Chat with us
                </v-btn> -->
                <a :href="`mailto:?subject=Email%20SRG%20From%20the%20Saved%20Listings%20Page!`" target="_blank" title="Email" style="text-decoration: none">
                    <v-btn @click.native="updateListing" class="elevation-1" color="success" style="color:#36480B; text-weight:900">
                        <v-icon class="mr-2" color="secondary">{{ icons.socailEmail }}</v-icon>Email us
                    </v-btn>
                </a>
            </div>
        </v-container>
        
        <div class="d-flex mt-12" style="background-color: #FFF">
            <v-container class="d-flex justify-space-between py-0">
                <div class="d-inline justify-start pt-10">
                    <h2 class="mb-6">Need Lending Assistance?</h2>
                    <p>Navigate over 30 lenders to find the best fit for you using our new tool LendingWell.</p>
                    <h4 class="mt-6">LendingWell will help you:</h4>
                    <ul class="mt-3 ml-3">
                        <li>Save time and money</li>
                        <li>Finance on your terms</li>
                        <li>Navigate the right solution quickly</li>
                    </ul>
                    <a href="http://successionresource-6155808.hs-sites.com/lendingwell" target="_blank" class="button_link"><v-btn class="my-9" color="primary" dark>Learn More</v-btn></a>
                </div>
                <v-spacer></v-spacer>
                <div class="d-inline justify-end">
                    <!-- <div class="buyer_download_image"></div> -->
                    <v-img :src="require(`@/assets/lendingwell_computer.jpg`)" style="height: 100%" contain alt="LendingWell.com"></v-img>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>
    //@click="showDesc(item.id)"
    import axios from "axios";
import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    import { mdiMagnify, mdiChevronDown, mdiChevronUp, mdiHeartCircleOutline, mdiHeart, mdiEmailVariant } from '@mdi/js'
    //import SRG_Succession_Planning_Case_Study from '../assets/SRG_Succession_Planning_Case_Study.png'
    let dateFormat = require('dateformat');

    import ModuleMenu from './ModuleMenu'
    import { toDollarsListings } from './utilities';

    export default {
        name: 'Listings',
        components: {
            ModuleMenu
        },
        data () {
            return {
                module_id: 3,
                header_text: 'Open Market Listings',
                readyToLoadInquired: false,
                readyToLoadFavs:  false,
                listings: [],
                favListings: [],
                interestListings: [],
                search: '',
                //SRG_Succession_Planning_Case_Study: SRG_Succession_Planning_Case_Study,
                icons: {
                    chevronDownIcon: mdiChevronDown,
                    chevronUpIcon: mdiChevronUp,
                    magnifyIcon: mdiMagnify,
                    heartIcon: mdiHeart,
                    heartCircleIcon: mdiHeartCircleOutline,
                    socailEmail: mdiEmailVariant,
                },
                listing_statuses: [
                    {   value: 1, text: 'Open', filter: 'open_listings' },
                    {   value: 2, text: 'Pending', filter: 'pending_listings' },
                    {   value: 3, text: 'Sold', filter: 'sold_listings' },
                    {   value: 4, text: 'Closed', filter: 'closed_listings' },
                ],

                feedbackDialog: false,
                feedback_type: '',
                feedback_msg: '',

            }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            listings () {
                this.filterFavListings();
            }
        },
        mounted () {
            this.getLists()
            
            setTimeout(() => {
                this.getListings()
            }, 1750);
        },
        methods: {

            getListings: async function () {
                setTimeout(() => {
                    axios.post(`${appUrls.api}/api/listings`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            'user_id': Cookie.get('id')
                        }
                    })
                    .then( res => {
                        if(res.data.outcome){
                            //console.log()
                            this.listings = res.data.listings;
                            let i = 0;
                            for( let listing of this.listings ) {
                                this.listings[i].post_date    = dateFormat(listing.post_date, "mm/dd/yyyy");
                                this.listings[i].listing_type = parseInt(this.listings[i].listing_type);
                                this.listings[i].status       = parseInt(this.listings[i].status);
                                
                                // LOCATION MODIFICATION
                                let vLoc = '';
                                if(listing.city !== '' && listing.state !== '') {
                                    vLoc = `${listing.city}, ${listing.state}`;
                                } else if(listing.city == '' && listing.state !== '') {
                                    vLoc = listing.state;
                                } else if(listing.city !== '' && listing.state == '') {
                                    vLoc = listing.city;
                                }
                                this.listings[i].location = vLoc;

                                // AUM TEXT
                                if (Number.parseFloat(this.listings[i].aum) >= 1000000) {
                                    let aum_text = Number.parseFloat(this.listings[i].aum / 1000000).toFixed(1)
                                    this.listings[i].aum_text = '$'+aum_text.replace(/\.?0*$/,'')+'M'
                                }else{
                                    this.listings[i].aum_text = toDollarsListings(Number.parseFloat(this.listings[i].aum))
                                }
                                
                                // REVENUE TEXT
                                if (Number.parseFloat(this.listings[i].revenue) >= 1000000) {
                                    let rev_text = Number.parseFloat(this.listings[i].revenue / 1000000).toFixed(1)
                                    this.listings[i].rev_text = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                                }else{
                                    this.listings[i].rev_text = toDollarsListings(Number.parseFloat(this.listings[i].revenue))
                                }

                                // IMAGE
                                this.listings[i].img = require(`@/assets/listings/states/${this.listings[i].state}.jpg`)

                                // STATUS
                                let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.listings[i].status);
                                this.listings[i].status_name = statusObj.text;

                                // TYPE NAME
                                let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listings[i].listing_type);
                                this.listings[i].type_name = typeObj.text;

                                // LOOK TO SEE IF THERE IS EVEN ANY RECORDS IN jbuyerstolistings FOR THIS USER & LISTING
                                let has_record = res.data.actions.find(row => parseInt(row.listing_id) === this.listings[i].id) ? true : false;
                                let interest_record = has_record ? res.data.actions.find(row => parseInt(row.listing_id) === this.listings[i].id) : false;

                                // INTERESTED
                                //console.log('has_record: '+has_record)
                                this.listings[i].interested     = has_record ? interest_record.interest ? true : false : false;
                                this.listings[i].interest_type  = has_record ? interest_record.interest ? "error" : "primary" : "primary";
                                this.listings[i].interest_text  = has_record ? interest_record.interest ? "Retract Interest" : "Express Interest" : "Express Interest";

                                // this.listings[i].interest_toggle = has_record ? "notshow" : "show";
                                // this.listings[i].interest_type   = has_record ? "error" : "primary";
                                // this.listings[i].interest_text   = has_record ? "I'm Interested" : "Express Interest";

                                // OFFER
                                //console.log('interest_record.offer: '+interest_record.offer)
                                this.listings[i].offer_made = interest_record ? interest_record.offer ? true : false : false;
                                this.listings[i].offer_type = interest_record ? interest_record.offer ? "error" : "primary" : "primary";
                                this.listings[i].offer_text = interest_record ? interest_record.offer ? 'Offer Made' : 'Make An Offer' : 'Make An Offer';

                                // FAV
                                this.listings[i].fav        = interest_record ? interest_record.fav ? true : false : false;
                                this.listings[i].fav_color  = interest_record ? interest_record.fav ? "warning" : "#999" : "#999";

                                i++;
                            }
                            //console.log(this.listings)
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }, 1500);
            },
            
            getLists: function () {
                let optionsLists = [ {'name': 'listing_types', 'type': 'int'}, {'name': 'buyer_status', 'type': 'int'}, {'name': 'states', 'type': 'txt'}];
                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        let arrLists = res.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'states') this.states = arrLists[l].list
                            if (arrLists[l].name == 'buyer_status') this.buyer_status = arrLists[l].list
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            filterFavListings: async function () {
                //console.log('filterListingsByStatus: triggered')
                let listing_status = [];
                this.favListings = this.listings.filter(row => {
                     return row.fav === true
                });
                this.readyToLoadFavs = true;


                this.interestListings = this.listings.filter(row => {
                     return row.interested === true
                });
                this.readyToLoadInquired = true;

                // for ( let obj in this.filterby) {
                //     console.log(obj)
                //     if( obj === true ) {
                //         id = this.listing_statuses.filter(row => {
                //             return 
                //         });
                //     }
                // }

                // if( this.filterby.open_listings ) {
                //     listing_status.push(1);
                // }

                // if( this.filterby.pending_listings ) {
                //     listing_status.push(2);
                // }

                // if( this.filterby.sold_listings ) {
                //     listing_status.push(3);
                // }

                // if( this.filterby.closed_listings) {
                //     listing_status.push(4);
                // }
                
                //console.log(listing_status)
                // FILTERING MAGIC BASED ON STATUS
                // this.filteredListings = this.listings.filter(row => {
                //     return listing_status.includes(parseInt(row.status)) === true
                //});
                //console.log(this.filteredListings);
            },
            
            updateListing ( listingId, action ) {
                axios.post(`${appUrls.api}/api/update_listing`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        'user_id': Cookie.get('id'),
                        'listing_id': listingId,
                        'action': action
                    }
                })
                .then( res => {
                    console.log(res.data.message)
                    this.getListings()
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            closeFeedbackDialog: function () {
                setTimeout(() => {
                    this.feedbackDialog = false
                }, 3000)
            },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }
    a.button_link {
        text-decoration-line: none
    }
    .min_height {
        min-height: 70vh;
    }
    .listing_header {
        font-size: 1.2em;
        font-weight: normal;
        color: #000;
    }
    .listing_header_secondary {
        font-size: 1em;
        font-weight: normal;
        color: #909090;
    }
    .buyer_download_image {
        min-width: 380px; 
        min-height: 380px; 
        background-image: url('https://www.successionresource.com/wp-content/uploads/2018/05/SRG_Succession-Planning-Case-Study.png'); 
        background-position: right -40px; 
        background-size: contain;
    }
    .view_listing {
        color:#0096a6; 
        font-size: 1.2em; 
        text-transform: uppercase
    }
</style>



// WEBPACK FOOTER //
// src/components/SavedListings.vue